import { Component, ViewEncapsulation } from "@angular/core";
import { FieldType, FormlyFieldConfig } from "@ngx-formly/core";

@Component({
    selector: "formly-field-icon",
    template: `<div class="flex gap-2 items-center">
        <mat-icon
            color="primary"
            class="h-4 w-4 min-h-4 min-w-4 max-h-4 max-w-4 text-sm"
            [svgIcon]="field.templateOptions.value"
        ></mat-icon>
        <span class="label" *ngIf="field.templateOptions.label">{{ field.templateOptions.label }}</span>
    </div>`,
    styleUrls: ["./icon.component.scss"],
})
export class FormlyFieldIcon extends FieldType {
    isValid(field: FormlyFieldConfig) {
        if (field.key) {
            return field.formControl.valid;
        }

        return field.fieldGroup ? field.fieldGroup.every((f) => this.isValid(f)) : true;
    }
}
